<template>
    <ValidationObserver v-slot="{ invalid, handleSubmit }">
        <form class="hello" @submit.prevent="handleSubmit(submitForm)">
            <div>
                <strong v-t="'feedback.privacy.title'"/>
            </div>
            <div class="remarks" v-t="'feedback.privacy.text'"/>
            <label>
                {{ $t('feedback.fields.concern') }} *
                <ValidationProvider :name="$t('feedback.fields.concern')">
                    <select v-model="concern" required>
                        <option value="" selected>{{ $t('feedback.controls.choose_entry') }}</option>
                        <option v-for="concern in concernList" :value="concern" :key="concern.id">
                            {{ $t('feedback.translations.concern.' + concern.name) }}
                        </option>
                    </select>
                </ValidationProvider>
            </label>
            <label>
                {{ $t('feedback.fields.comment') }} *
                <ValidationProvider :name="$t('feedback.fields.comment')">
                    <textarea v-model="comment" required/>
                </ValidationProvider>
            </label>
            <label>
                {{ $t('feedback.fields.status') }} *
                <ValidationProvider :name="$t('feedback.fields.status')">
                    <select v-model="personGroup" required>
                        <option value="" selected>{{ $t('feedback.controls.choose_entry') }}</option>
                        <option v-for="personGroup in personGroupList" :value="personGroup" :key="personGroup.id">
                            {{ $t('feedback.translations.persongroup.' + personGroup.name) }}
                        </option>
                    </select>
                </ValidationProvider>
            </label>
            <fieldset>
                <h2 v-t="'feedback.headings.contact_data'"/>
                <fieldset style="margin-bottom: 0.6em">
                    <label v-t="'feedback.fields.title'"/>
                    <label class="container" v-for="addressings in addressingList" :key="addressings.id">
                        {{ $t('feedback.translations.addressings.' + addressings.name) }}
                        <input type="radio" :id="addressings.id" :value="addressings" v-model="addressing" autocomplete="honorific-prefix" style="width: 0px">
                        <span class="checkmark"></span>
                    </label>
                </fieldset>
                <label>
                    {{ $t('feedback.fields.firstname') }} *
                    <ValidationProvider :name="$t('feedback.fields.firstname')">
                        <input type="text" v-model="firstname" required autocomplete="given-name">
                    </ValidationProvider>
                </label>
                <label>
                    {{ $t('feedback.fields.lastname') }} *
                    <ValidationProvider :name="$t('feedback.fields.lastname')">
                        <input type="text" v-model="lastname" required autocomplete="family-name">
                    </ValidationProvider>
                </label>
                <label>
                    {{ $t('feedback.fields.email') }} *
                    <ValidationProvider :name="$t('feedback.fields.email')">
                        <input :title="$t('feedback.fields.email_hint')" type="email" v-model="email" required autocomplete="email">
                    </ValidationProvider>
                </label>
                <label>
                    {{ $t('feedback.fields.phone') }}
                    <input type="tel" v-model="phone" autocomplete="tel">
                </label>
            </fieldset>
            <fieldset v-if="isStudent || isGraduate || isFacultyMember || isFacilityMember || isUniversityMember">
                <h2 v-t="'feedback.headings.remarks'"/>
                <label v-if="isStudent || isGraduate || isFacultyMember">
                    {{ $t('feedback.fields.faculty') }}
                    <select v-model="faculty">
                        <option value="empty" key="empty" selected>{{ $t('feedback.controls.choose_entry') }}</option>
                        <option v-for="faculty in facultyList" :value="faculty" :key="faculty.id">
                            {{ $t('feedback.translations.faculty.' + faculty.name) }}
                        </option>
                    </select>
                </label>
                <label v-if="faculty !== 'empty' && isStudent">
                    {{ $t('feedback.fields.program') }}
                    <select v-model="course">
                        <option value="empty" key="empty" selected>{{ $t('feedback.controls.choose_entry') }}</option>
                        <option v-for="course in filteredCourses" :value="course" :key="course.id">
                            {{ course.name.replace(/\w*\s/, '') }}
                        </option>
                    </select>
                </label>
                <label v-if="isStudent">
                    {{ $t('feedback.fields.semester') }}
                    <select v-model="semester">
                        <option value="empty" key="empty" selected>{{ $t('feedback.controls.choose_entry') }}</option>
                        <option v-for="semester in semesterList" :value="semester" :key="semester.id">
                            {{ semester.name }}
                        </option>
                    </select>
                </label>
                <label v-if="isFacilityMember">
                    {{ $t('feedback.fields.department') }}
                    <select v-model="department">
                        <option value="empty" key="empty" selected>{{ $t('feedback.controls.choose_entry') }}</option>
                        <option v-for="department in departmentList" :value="department" :key="department.id">
                            {{ department.name }}
                        </option>
                    </select>
                </label>
                <label v-if="isUniversityMember">
                    {{ $t('feedback.fields.institution') }}
                    <select v-model="facility">
                        <option value="empty" key="empty" selected>{{ $t('feedback.controls.choose_entry') }}</option>
                        <option v-for="facility in facilityList" :value="facility" :key="facility.id">
                            {{ facility.name }}
                        </option>
                    </select>
                </label>
            </fieldset>
            <br/>
            <label>
                {{ $t('feedback.fields.origin') }}
                <select v-model="origin">
                    <option value="empty" key="empty" selected>{{ $t('feedback.controls.choose_entry') }}</option>
                    <option v-for="origin in originList" :value="origin" :key="origin.id">
                        {{ $t('feedback.translations.origin.' + origin.name) }}
                    </option>
                </select>
            </label>
            <hr>
            <input type="submit" :value="$t('feedback.controls.submit')"/>
        </form>
    </ValidationObserver>
</template>

<script>
import {eventBus} from "@/main";
import {extend, ValidationProvider, ValidationObserver} from 'vee-validate';
import {email, required} from 'vee-validate/dist/rules';

// No message specified.
extend('email', email);

// Override the default message.
extend('required', {
    ...required,
    message: 'This field is required'
});

export default {
    name: 'FeedbackForm',
    components: {
        ValidationProvider, ValidationObserver
    },
    data: () => ({
        invalid: true,
        concernList: [],
        addressingList: [],
        personGroupList: [],
        facultyList: [],
        courseList: [],
        semesterList: [],
        departmentList: [],
        facilityList: [],
        originList: [],
        concern: '',
        comment: '',
        personGroup: '',
        addressing: '',
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        faculty: 'empty',
        course: 'empty',
        semester: 'empty',
        department: 'empty',
        facility: 'empty',
        origin: 'empty'
    }),
    methods: {
        submitForm() {
            this.axios.post(`/feedbackform/data/feedback`, this.createFeedback()).then(response => {
                eventBus.$emit('formSubmitted', response.data.number);
            });
        },
        createFeedback() {
            return {
                concern: this.checkValue(this.concern),
                comment: this.comment,
                addressing: this.checkValue(this.addressing),
                firstname: this.firstname,
                lastname: this.lastname,
                email: this.email,
                phone: this.phone,
                personGroup: this.checkValue(this.personGroup),
                faculty: this.checkValue(this.faculty),
                course: this.checkValue(this.course),
                semester: this.checkValue(this.semester),
                department: this.checkValue(this.department),
                facility: this.checkValue(this.facility),
                origin: this.checkValue(this.origin)
            };
        },
        checkValue(value) {
            return (value && value !== 'empty') ? value : {id: '', name: ''}
        }
    },
    computed: {
        filteredCourses: function () {
            return this.courseList.filter(course => course.name.includes('F'+this.faculty.clientReferenceNumber))
        },
        isStudent: function () {
            return this.personGroup.name && this.personGroup.name.includes('Studierende')
        },
        isGraduate: function () {
            return this.personGroup.name && this.personGroup.name.includes('Absolventen')
        },
        isFacultyMember: function () {
            return this.personGroup.name && this.personGroup.name.includes('Fakultätsangehörige')
        },
        isFacilityMember: function () {
            return this.personGroup.name && this.personGroup.name.includes('Verwaltungsangehörige')
        },
        isUniversityMember: function () {
            return this.personGroup.name && this.personGroup.name.includes('Weitere Hochschulangehörige')
        }
    },
    created() {
        const sortFunction = function sortAlphaNum(a, b) {
            return a.name.localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'})
        };

        this.axios.get(`/feedbackform/data/concerns`).then(response => {
            this.concernList = response.data;
        });
        this.axios.get(`/feedbackform/data/addressings`).then(response => {
            this.addressingList = response.data;
        });
        this.axios.get(`/feedbackform/data/persongroups`).then(response => {
            this.personGroupList = response.data;
        });
        this.axios.get(`/feedbackform/data/faculties`).then(response => {
            this.facultyList = response.data.sort(sortFunction);
        });
        this.axios.get(`/feedbackform/data/courses`).then(response => {
            this.courseList = response.data;
        });
        this.axios.get(`/feedbackform/data/semester`).then(response => {
            this.semesterList = response.data;
        });
        this.axios.get(`/feedbackform/data/departments`).then(response => {
            this.departmentList = response.data.sort(sortFunction);
        });
        this.axios.get(`/feedbackform/data/facilities`).then(response => {
            this.facilityList = response.data.sort(sortFunction);
        });
        this.axios.get(`/feedbackform/data/origins`).then(response => {
            this.originList = response.data;
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
    font-size: 1.25em;
    font-weight: 600;
    line-height: 1.2em;
    margin-bottom: 0.6em;
}

strong {
    font-weight: 600;
    margin-bottom: 1em;
    display: block;
}

.remarks {
    margin-bottom: 1em;
}

label {
    width: auto;
    font-weight: 600;
    line-height: 1.4em;
    margin: 0;
}

input {
    box-sizing:border-box;
    width: 100%;
    font-size: 0.938em;
    font-weight: 400;
    padding: 0.325em 4px;
    margin-top: 0.3em;
    margin-bottom: 0.6em;
    background-color: transparent;
    border: 1px solid #888
}

input:focus {
    border: 1px solid #000;
}

/* The container */
.container {
    display: block;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
    font-size: 0.938em;
    font-weight: 400;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin-top: 0.3em;
}

/* Hide the browser's default radio button */
.container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 17px;
    width: 17px;
    background: url(https://www.th-koeln.de/img/icons/select-default.svg);
    border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
    background: url(https://www.th-koeln.de/img/icons/select-active.svg);
}

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
    background: url(https://www.th-koeln.de/img/icons/select-active.svg);
}

select {
    width: 100%;
    font-size: 0.938em;
    font-weight: 400;
    padding: 0.325em 0;
    margin-top: 0.3em;
    margin-bottom: 0.6em;
    background-color: transparent;
    border: 1px solid #888;
    box-sizing: content-box;
}

select:focus {
    border: 1px solid #000;
}

textarea {
    font-family: Arial, Helvetica, sans-serif;
    box-sizing:border-box;
    width: 100%;
    height: 7.08em;
    font-size: 0.938em;
    font-weight: 400;
    padding: 0.325em 4px;
    margin-top: 0.3em;
    margin-bottom: 0.6em;
    background-color: transparent;
    border: 1px solid #888
}

textarea:focus {
    border: 1px solid #000;
}

input[type=submit] {
    font-size: 1.188em;
    font-weight: 600;
    background: url(https://www.th-koeln.de/img/icons/link-intern.svg) no-repeat right .5em;
    background-size: 12px 12px;
    line-height: normal;
    width: 100%;
    text-align: right;
    margin-bottom: 0.5em;
    padding-right: 0.9em;
    border: 0;
    float: right;
    cursor: pointer;
}

hr {
    border: 0;
    border-top: 1px solid #ccc;
    clear: both;
    display: block;
    height: 1px;
    margin: 1em 0;
    padding: 0;
}

fieldset {
    border: none;
    margin: 0;
    padding: 0;
}
</style>
